import { ChangeDetectorRef, Component, HostListener } from '@angular/core'
import { Title, Meta } from '@angular/platform-browser'

@Component({
  selector: 'app-blog',
  templateUrl: 'blog.component.html',
  styleUrls: ['blog.component.css'],
})
export class BlogComponent {
  screenWidth: number;
  constructor(private cdr: ChangeDetectorRef) {
    this.getScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    setTimeout(() => {
      this.screenWidth = screen.width;
      this.cdr.detectChanges(); // Detect changes manually
    });
  }
}
